import { Link } from 'foundations-components/transitional/components/Link';
import { trackEvent } from '../../../../usage-tracking/clients/usageTracker';
import { getOpenCitation } from '../../events/ReplyRecommendationCitationEvents';
import { ReplyRecommendationCitationCopyButton } from './ReplyRecommendationCitationCopyButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReplyRecommendationCitation = ({
  citation
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Link, {
      external: true,
      href: citation.deepLink || citation.url,
      "data-test-id": 'reply-recommendation-citation',
      onClick: () => {
        trackEvent(getOpenCitation());
      },
      children: citation.title || citation.url
    }), /*#__PURE__*/_jsx(ReplyRecommendationCitationCopyButton, {
      citation: citation
    })]
  });
};
ReplyRecommendationCitation.displayName = 'ReplyRecommendationCitation';